'use strict';

import Loader from '../../_modules/loader/loader';
import { toaster } from '../../_assets/abbott/js/_material';

export default class SohModalStaffShop {
	constructor() {
		let that = this;

		$('.js-back-to-regimen').on('click', function(){
			that.reviewRegimen();
		});
		
	}
	
	removeDisabled(){
		$('.disabled').each(function(){
			$(this).removeClass('disabled');
		});
	}

	displaySohModal(){

		this.removeDisabled();

		let isMobileDevice = Modernizr.mq('(max-width: 767px)'),
			that = this,
			option;

		$.fancybox.open('#soh-modal', {
			autoSize: true,
			closeBtn: false,
			fitToView: true,
			minWidth: isMobileDevice == true ? 250 : 768,
			padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
			type: 'inline',
			wrapCSS: 'modal',
			afterShow: function(){
				$('.js-override-order').on('click', function (e){
					option = 'override';

					$.fancybox.close();
				});

				$('.js-review-regimen').on('click', function (e){
					option = 'review';
					$.fancybox.close();
				});
			},
			afterClose: function(){
				//need to call functions after closing to avoid to fire them too often

				setTimeout(function () {

					switch(option){
						case 'override': 
							// let overrideOrder = new OrderOverride();
							// overrideOrder.getCurrentStock();
							// that.toggleMultiStepNav(true);
							// that.scrollTo($('#main'));
							break;
						case 'review': that.reviewRegimen();
						    		   break;
						default:
						    break;
					}
				}, 250);
			}
		});
	};

	populateSohModalList(data){
		let $list = $('#soh-modal__list'),
			fragment = $(document.createDocumentFragment());

		$list.empty();

	  	for (var i = 0, len = data.length; i < len; i++) {
			fragment.append(
		  		$('<li></li>')
					.text(data[i])
			);
	 	}

		$list.append(fragment);
	};

	getOrderProducts(){
		let prodObj = {},
			_firstOrderProducts = [],			
			$createRegimenForm = $('section.view-create-order'),
			$firstOrderOverrideContainer = $('.product-details'),
			$firstOrderProductRow = $firstOrderOverrideContainer.find('.product-details__row'),
			that = this;

		$firstOrderProductRow.each(function () {
			let $this = $(this),
				isMixed = $this.find('.flavours-listing li[data-name="Mixed"]').hasClass('selected');

				prodObj = {};
				prodObj.Id = isMixed == true ? null : $this.find('.flavours-listing li.selected').data('prod-id');
				prodObj.MixedFlavour = isMixed;
				prodObj.ProductTypeId = $this.data('prod-type-id');
				prodObj.Quantity = $this.find('.product-quantity__value .counter-value').val();
				prodObj.IsSpecial = $this.data('is-special');

			_firstOrderProducts.push(prodObj);
		});

		return _firstOrderProducts;
	};

	/* check whether selected products are in stock.
	** - if Out of Stock: display modal window
	** - else: regimen will be created
	*/
	_isInStock() {

		let that = this,
			loader = new Loader(),
			dataParams,
			$createRegimenForm = $('section.view-create-order'),
			$firstOrderOverrideContainer = $('.product-details'),
			$firstOrderProductRow = $firstOrderOverrideContainer.find('.product-details__row'),
			_firstOrderProducts = that.getOrderProducts();

		if(typeof _firstOrderProducts === 'undefined')
			return true;

		loader.fadeIn();

		dataParams ={
			"PostCode": $('#postal_code').val(),
			"Products": _firstOrderProducts,
            "InstitutionId": $('#InstitutionId').val()
		};

		//var encodedParams = jQuery.param(dataParams);

		return $.ajax({
			url: '/api/products/checkStock',
			dataType: 'json',
			contentType: 'application/json; charset=utf-8',
			type: 'POST',
			data: JSON.stringify(dataParams),
			success: function (data) {

				if(!data.IsInStock){
					that.populateSohModalList(data.ProductsOutOfStock);
					that.displaySohModal();
				}

				loader.fadeOut();
			},
			error: function (error) {
				loader.fadeOut();
				toaster('Something went wrong.','error');
			}
		})
	};

	reviewRegimen(){
		let that = this,
		$createRegimenForm = $('section.view-create-order'),
		$firstOrderOverrideContainer = $('.product-details'),
		$firstOrderProductRow = $firstOrderOverrideContainer.find('.product-details__row');

		that.scrollTo($firstOrderOverrideContainer);
	};

	scrollTo($el){
		let $offsetHeight = $('.header').height();

  	    $('html, body').animate({
  	        scrollTop: $( $el ).offset().top - $offsetHeight
  	    }, 1000);
	};
}
